<template>
    <div>
        <b-form class="step-form" @submit.stop.prevent="onSubmit">
            <div v-if="!showPageLoader" class="row">
                <div class="col-lg-12">
                    <div class="row">
                        <div
                            v-for="(field, index) in fields"
                            :key="index"
                            :class="{
                                [field.class]: true,
                                'col-lg-12': field.column == 12,

                                'col-md-3': field.column == 3,
                                'col-md-4': field.column == 4,

                                'col-md-6':
                                    field.column == 6 ||
                                    field.type == 'phone-number',
                                'col-md-8': field.column == 8,
                            }"
                        >
                            <div
                                v-if="field.type == 'heading' && index > 0"
                                class="form-border"
                            ></div>

                            <component
                                :is="field.type"
                                :field="field"
                                :data-segment-id="dataSegmentId"
                                @onBlur="onBlur"
                                @saveData="onSave"
                            ></component>
                            <!-- remove this line because dropdown is not working  @select="selectedIsd"-->
                        </div>
                        <div class="col-lg-12">
                            <div class="form-border"></div>
                        </div>
                    </div>
                    <b-button
                        size="sm"
                        class="mr-3"
                        variant="secondary"
                        @click="onBack"
                    >
                        Back
                    </b-button>
                    <b-button
                        type="button"
                        variant="primary"
                        class="primary-add-btn mr-3"
                        @click="onSave"
                        >SAVE
                    </b-button>
                    <base-button
                        btn-type="submit"
                        btn-variant="primary"
                        btn-label="CONTINUE"
                        class="mr-3"
                        :class="loading ? 'disabled' : ''"
                        :disabled="loading"
                    ></base-button>

                    <span v-if="loading" class="secondary-color">
                        Please wait. We're processing your request...</span
                    >
                </div>
            </div>
            <!-- When data is loading -->
            <base-table-spinner v-if="showPageLoader"></base-table-spinner>
        </b-form>
        <b-modal
            ref="pmda"
            size="md"
            title="Warning"
            hide-footer
            :click-to-close="false"
            :no-close-on-backdrop="true"
            :no-close-on-esc="true"
        >
            <pmda-modal @selection="acceptPmda"></pmda-modal>
        </b-modal>
        <b-modal
            ref="identityNumberExists"
            size="md"
            title="Warning"
            hide-footer
            :click-to-close="false"
            :no-close-on-backdrop="true"
            :no-close-on-esc="true"
        >
            <div class="wrapper">
                <h5 style="margin-bottom: 25px">
                    {{ `${errorMsg} Please contact support@alfalahghp.com.` }}
                </h5>
                <b-button
                    size="sm"
                    class="mr-3"
                    variant="secondary"
                    @click="onClick"
                >
                    CLOSE
                </b-button>
            </div>
        </b-modal>
    </div>
</template>
<script>
import { mapGetters } from 'vuex'
import { mapState } from 'vuex'

import request from '@/utils/request'

import Heading from '@/components/registration/Heading.vue'
import TextField from '@/components/registration/TextField.vue'
import TextArea from '@/components/registration/TextArea.vue'
import DatePicker from '@/components/registration/DatePicker.vue'
import List from '@/components/registration/List.vue'
import Dropdown from '@/components/registration/Dropdown.vue'
import Radio from '@/components/registration/Radio.vue'
import Checkbox from '@/components/registration/Checkbox.vue'
import PhoneNumber from '@/components/registration/PhoneNumber.vue'
import IdentityType from '@/components/registration/IdentityType.vue'
import IdentityDocumentExpiry from '@/components/registration/IdentityDocumentExpiry.vue'
import Country from '@/components/registration/Country.vue'
import Nationality from '@/components/registration/Nationality.vue'
import TaxId from '@/components/registration/TaxId.vue'
import WorkType from '@/components/registration/WorkType.vue'
import Industry from '@/components/registration/Industry.vue'
import OtherNationalities from '@/components/registration/OtherNationalities'


export default {
    /*
|--------------------------------------------------------------------------
| Component > components
|--------------------------------------------------------------------------
*/
    components: {
        Heading,
        TextField,
        TextArea,
        DatePicker,
        List,
        Dropdown,
        Radio,
        Checkbox,
        PhoneNumber,
        IdentityType,
        IdentityDocumentExpiry,
        Country,
        Nationality,
        TaxId,
        WorkType,
        Industry,
        OtherNationalities,
    }, // End of Component > components

    /*
|--------------------------------------------------------------------------
| Component > props
|--------------------------------------------------------------------------
*/
    props: {}, // End of Component > props

    /*
|--------------------------------------------------------------------------
| Component > data
|--------------------------------------------------------------------------
*/
    data() {
        return {
            section: 'setup-profile',
            fields: [],
            showPageLoader: true,
            errorMsg: null,
        }
    }, // End of Component > data

    /*
|--------------------------------------------------------------------------
| Component > computed
|--------------------------------------------------------------------------
*/
    computed: {
        ...mapState({
            restrictDuplicateCustomers: (state) =>
                state.registration.restrictDuplicateCustomers,
        }),

        ...mapGetters(['loading', 'dataSegmentId']),

        dataSegmentId() {
            if (this.$route.params.dataSegmentId) {
                return this.$route.params.dataSegmentId
            }
            return this.$store.getters.dataSegmentId
        },
    }, // End of Component > mounted

    /*
|--------------------------------------------------------------------------
| Component > watch
|--------------------------------------------------------------------------
*/
    watch: {
        dataSegmentId(value) {
            if (value) {
                this.getRecords()
            }
        },
    }, // End of Component > watch

    /*
|--------------------------------------------------------------------------
| Component > mounted
|--------------------------------------------------------------------------
*/
    mounted() {
        console.log(
            'identity info ',
            this.$store.state.registration.form.identityInfo
        )
        this.getRecords()
        let routerName = this.$route.name
    }, // End of Component > computed
    /*
|--------------------------------------------------------------------------
| Component > methods
|--------------------------------------------------------------------------
*/
    methods: {
        validateAllCustom(formData) {
            //future date of birth check
            if (
                formData &&
                formData.basicInfo &&
                formData.basicInfo.dateOfBirth
            ) {
                // console.log(formData.basicInfo.dateOfBirth)
                // console.log(new Date())
                if (formData.basicInfo.dateOfBirth > new Date()) {
                    return {
                        valid: false,
                        error: 'Date of birth can not be a future date',
                    }
                }
            }

            // Issuance date should not be less than Date of Birth
            if (
                formData &&
                formData.identityInfo &&
                formData.basicInfo.dateOfBirth
            ) {
                for (let i = 0; i < formData.identityInfo.length; i++) {
                    // // const index = this.fields.findIndex((field) => {
                    // //   if (field.label === 'Issuance Date') {
                    // //     return true
                    // //   }
                    // // })
                    // // // console.log("INDEX : " + index)
                    // // this.fields[index]['isInvalid'] = true
                    // return {
                    //     valid: false,
                    //     error: `Issuance Date (${i+1}) should not be less than Date of Birth`,
                    // }

                    if (formData.identityInfo[i].IssuanceDate) {
                        // console.log('dob issue date', i + 1)
                        const result = this.earlierDateValidator(
                            formData.basicInfo.dateOfBirth,
                            'Date of Birth',
                            formData.identityInfo[i].IssuanceDate,
                            `Issuance Date (${i + 1})`
                        )

                        if (result && !result.valid) {
                            console.log('result')
                            return result
                        }
                    }
                }
            }

            // Issuance Date earlier than expiry date
            if (formData && formData.identityInfo) {
                for (let i = 0; i < formData.identityInfo.length; i++) {
                    if (
                        formData.identityInfo[i].IssuanceDate &&
                        formData.identityInfo[i].expiryDate
                    ) {
                        const result = this.earlierDateValidator(
                            formData.identityInfo[i].IssuanceDate,
                            `Issuance Date (${i + 1})`,
                            formData.identityInfo[i].expiryDate,
                            `Expiry Date (${i + 1})`
                        )

                        if (result && !result.valid) {
                            console.log('result 2')
                            return result
                        }
                    }
                }
            }

            // Age should be greater than 18
            // if (formData.basicInfo && formData.basicInfo.dateOfBirth) {
            //     let TODAY = new Date(Date.now())
            //     let EIGHTEEN_YEARS_BACK = new Date(
            //         new Date(TODAY).getDate() +
            //             '/' +
            //             new Date(TODAY).getMonth() +
            //             '/' +
            //             (new Date(TODAY).getFullYear() - 18)
            //     )
            //     let result =
            //         EIGHTEEN_YEARS_BACK > formData.basicInfo.dateOfBirth

            //     if (!result) {
            //         const index = this.fields.findIndex((field) => {
            //             if (field.label === 'Date of Birth') {
            //                 return true
            //             }
            //         })
            //         if (index) {
            //             this.fields[index]['isInvalid'] = true
            //         }
            //         return {
            //             valid: false,
            //             error: 'Age should be greater than 18',
            //         }
            //     }
            // }
        },
        onBlur(value) {
            // console.log('value ', value)
            this.checkIdentityNumber(value)
        },

        onBack() {
            this.$router.push({
                name: 'edit-identity-document',
            })
        },

        async checkIdentityNumber(value) {
            let dataSegmentId = this.dataSegmentId
            if (dataSegmentId) {
                try {
                    const params = {}
                    params.dataSegmentId = dataSegmentId
                    params.number = value

                    const { data } = await request({
                        url: `/customers/exists`,
                        method: 'get',
                        params,
                    })
                    // console.log('response: ', data)
                    if (!data.exists) {
                        this.$store.commit('updateField', {
                            key: 'identityInfo.number',
                            value: value,
                        })
                    }
                    // console.log(this.$store.state.registration.form.identityInfo.number)
                } catch (e) {
                    this.errorMsg = e
                    this.$refs.identityNumberExists.show()
                    // console.log('error: ', e)
                }
            }
        },
        onClick() {
            this.$refs.identityNumberExists.hide()
            this.$store.commit('updateField', {
                key: 'identityInfo.number',
                value: null,
            })
        },

        // Comparison between Dates Validation
        earlierDateValidator(
            earlierDate,
            earlierDateLabel,
            lateDate,
            lateDateLabel
        ) {
            // if (earlierDate > lateDate) {
            //     // const index = this.fields.findIndex((field) => {
            //     //   if (field.label === "Issuance Date") {
            //     //     return true;
            //     //   }
            //     // });
            //     // // console.log("INDEX : " + index)
            //     // this.fields[index]["isInvalid"] = true;
            //     return {
            //         valid: false,
            //         error:
            //             earlierDateLabel +
            //             ' should be earlier than ' +
            //             lateDateLabel,
            //     }
            // }
            let a = new Date(earlierDate)
            let b = new Date(lateDate)

            if (a.getTime() > b.getTime()) {
                return {
                    valid: false,
                    error:
                        earlierDateLabel +
                        ' should be earlier than ' +
                        lateDateLabel,
                }
            }
        },

        acceptPmda() {
            this.$refs.pmda.hide()
            this.submit2()
        },
        submit2() {
            this.$store.commit('updateField', {
                key: 'forms.form2.valid',
                value: true,
            })
            /**
             * Pre Populate Fatca Info
             */
            if (this.$store.state.registration.form.identityInfo.type == 'id') {
                this.$store.commit('updateField', {
                    key: 'fatcaInfo.CNICNumber',
                    value: this.$store.state.registration.form.identityInfo
                        .number,
                })
            }

            this.$store.commit('updateField', {
                key: 'fatcaInfo.titleOfAcc',
                value: this.$store.state.registration.form.basicInfo.firstName,
            })

            this.$store.commit('updateField', {
                key: 'fatcaInfo.placeOfBirth',
                value: this.$store.state.registration.form.basicInfo
                    .placeOfBirth,
            })

            /**
             * Pre Populate Fatca Info End
             */

            if (this.$route.meta.publicRegistration === true) {
                this.$router.push({
                    name: 'public-registration-contact-info',
                    params: {
                        dataSegmentId: this.dataSegmentId,
                    },
                })
            } else {
                // console.log(this.$store.state.registration.form)
                this.$router.push({ name: 'edit-account-info' })
            }
        },

        onContinue(formData) {
            //ADD CONDITION HERE IF MOBILE NUMBER REGISTERED ON CNIC

            // console.log('isd code ', formData.contactInfo.isdCode)
            if (
                formData.contactInfo.isdCode == '+92' &&
                formData.identityInfo.type == 'id'
            ) {
                // this.$refs.pmda.show()
                this.pmdAPICall()
            } else {
                this.submit2()
            }
        },

        async pmdAPICall() {
            try {
                // console.log("Full :"+JSON.stringify(this.$store.state.registration.form) )
                let mobileNumber =
                    this.$store.state.registration.form.contactInfo.phoneNumber
                let cnic =
                    this.$store.state.registration.form.identityInfo.number

                let dataSegmentId = this.dataSegmentId

                this.$store.commit('setLoading', true)
                // let phoneNumber = '923333728009'

                const formData = {
                    mobileNumber: mobileNumber,
                    cnic: cnic.replace(/-/g, ''),
                    dataSegmentId: dataSegmentId,
                }

                // console.log('PHONE NUMBER: ' + phoneNumber)
                let encryptedForm = this.CryptoJS.AES.encrypt(
                    JSON.stringify(formData),
                    process.env.VUE_APP_CRYPTO_SECERT_KEY
                ).toString()

                const { data } = await request({
                    url: `/configurations/pmd-verification`,
                    // url:'https://pkdev.idenfo.net/api/configurations/pmd-verification',
                    method: 'post',
                    data: { data: encryptedForm },
                })

                // console.log("data ", JSON.stringify(data))
                if (data) {
                    // console.log("data ", data.data.responseCode)
                    // console.log("data ", data.data.status)
                    // console.log("data ", data.data.message)

                    if (data.data.responseCode == '-1' || data.data.responseCode == -1) {
                        // api fail
                        this.$store.state.registration.form.pmd.pmdVerificationStatus = 'N/A'
                        this.submit2()

                    } else if(data.data.responseCode == '01'){
                        this.$store.state.registration.form.pmd.pmdVerificationStatus =
                            'Yes'
                        this.submit2()

                    } else {
                        this.$store.state.registration.form.pmd.pmdVerificationStatus =
                            'No'
                        this.$refs.pmda.show()
                    }
                }else{
                    this.$store.state.registration.form.pmd.pmdVerificationStatus = 'N/A'
                    this.submit2()
                }

                this.$store.commit('setLoading', true)
                // console.log('Response OTP data: ' + JSON.stringify(data))
                // this.fields = data.data
            } catch (error) {
                this.$store.state.registration.form.pmd.pmdVerificationStatus =
                    'N/A'
                    // 'No'
                this.submit2()
                // console.log('OTP error: ' + error)
            }

            this.$store.commit('setLoading', false)
        }, // End of sendOtp() method

        /**
         * Handle when the form has been submitted
         *
         * @return {void}
         */
        async onSubmit() {
            // validate the form fields

            const result = await this.$validator.validateAll()
            // const result = true // Just for checking purpose.

            // Form State Data
            const formData = this.$store.state.registration.form

            const resultCustom = this.validateAllCustom(formData)

            // console.log(formData.recievePmdaOption)
            // console.log(formData.contactInfo.isdCode)
            // Check if validation fails
            if (result) {
                if (resultCustom && !resultCustom.valid) {
                    this.$store.commit('updateField', {
                        key: 'forms.form2.valid',
                        value: false,
                    })
                    this.$store.commit(
                        'setError',
                        resultCustom && resultCustom.error
                            ? resultCustom.error
                            : ''
                    )
                } else {
                    // this.onContinue(formData)

                    this.submit2()
                }
                // }
            } else {
                this.$store.commit('updateField', {
                    key: 'forms.form2.valid',
                    value: false,
                })
                this.$store.commit('setError', this.errors.all()[0])
                console.log('Errors', this.errors.all())
            }
        }, // End of onSubmit() method

        /**
         * get the form fields when required
         *
         * @return {void}
         */
        async getRecords() {
            try {
                console.log('test check')
                console.log(this.dataSegmentId)
                console.log(this.section)
                let { data } = await request({
                    url: `/form-builder/`,
                    params: {
                        dataSegmentId: this.dataSegmentId,
                        section: this.section,
                    },
                })
                console.log('checks')

                this.showPageLoader = false
                this.fields = data.data

                // this.getDraftCustomer()
                // console.log('Form Results: ' + JSON.stringify(data))
            } catch (error) {
                console.log('Setup-Profile-error ' + error)
            }
            this.$store.commit('setLoading', false)
        }, // End of getRecords() method

        async onSave() {
            const result = await this.$validator.validateAll()
            // Form State Data
            const formData = this.$store.state.registration.form

            const resultCustom = this.validateAllCustom(formData)

            // Check if validation fails
            if (result) {
                if (resultCustom && !resultCustom.valid) {
                    this.$store.commit('updateField', {
                        key: 'forms.form2.valid',
                        value: false,
                    })
                    this.$store.commit(
                        'setError',
                        resultCustom && resultCustom.error
                            ? resultCustom.error
                            : ''
                    )
                } else {
                    let registrationUrl =
                        '/customers/update-individual-customer'
                    this.$store.commit('setLoading', true)

                    try {
                        const formData = this.$store.state.registration.form
                        // formData.dataSegmentId = this.dataSegmentId

                        const { data } = await request({
                            url: registrationUrl,
                            method: 'post',
                            data: formData,
                        })

                        this.$toasted.show('Changes saved successfully', {
                            duration: 3000,
                            type: ['success'],
                        })

                        this.$store.commit('setLoading', false)
                    } catch (errors) {
                        this.$store.commit('setError', errors)
                        this.$store.commit('setLoading', false)
                    }
                }
                // }
            } else {
                this.$store.commit('updateField', {
                    key: 'forms.form2.valid',
                    value: false,
                })
                this.$store.commit('setError', this.errors.all()[0])
                // console.log('Errors', this.errors.all())
            }

            // }
        },
    },
} // End of export default
</script>
